import { ReactComponent as WebIcon } from '../assets/web.svg';
import { ReactComponent as FacebookIcon } from '../assets/facebook.svg';
import { ReactComponent as YoutubeIcon } from '../assets/youtube.svg';
import { ReactComponent as VkontakteIcon } from '../assets/vkontakte.svg';
import { ReactComponent as TwitterIcon } from '../assets/twitter.svg';
import { ReactComponent as TelegramIcon } from '../assets/telegram.svg';
import { ReactComponent as OkIcon } from '../assets/odnoklassniki.svg';
import { ReactComponent as TikTokIcon } from '../assets/tiktok.svg';
import { ReactComponent as InstagramIcon } from '../assets/instagram.svg';
import { ReactComponent as ThreadsIcon } from '../assets/threads.svg';
import { ReactComponent as LinkedinIcon } from '../assets/linkedin.svg';
import { ReactComponent as ZhihuIcon } from '../assets/zhihu.svg';
import { ReactComponent as PincongIcon } from '../assets/pincong.svg';
import { ReactComponent as MaxIcon } from '../assets/max.svg';
import { ReactComponent as HupuIcon } from '../assets/hupu.svg';
import { ReactComponent as WeiboIcon } from '../assets/weibo.svg';
import { ReactComponent as DouyinIcon } from '../assets/douyin.svg';
import { ReactComponent as DarkWebIcon } from '../assets/darkWeb.svg';
import { ReactComponent as RedditIcon } from '../assets/reddit.svg';
import { ReactComponent as BlueSkyIcon } from '../assets/blueSky.svg';
import { ReactComponent as WebIconCircle } from '../assets/webCircle.svg';
import { ReactComponent as FacebookIconCircle } from '../assets/facebookCircle.svg';
import { ReactComponent as YoutubeIconCircle } from '../assets/youtubeCircle.svg';
import { ReactComponent as VkontakteIconCircle } from '../assets/vkontakteCircle.svg';
import { ReactComponent as TwitterIconCircle } from '../assets/twitterCircle.svg';
import { ReactComponent as TelegramIconCircle } from '../assets/telegramCircle.svg';
import { ReactComponent as OkIconCircle } from '../assets/odnoklassnikiCircle.svg';
import { ReactComponent as TikTokIconCircle } from '../assets/tiktokCircle.svg';
import { ReactComponent as InstagramIconCircle } from '../assets/instagramCircle.svg';
import { ReactComponent as ThreadsIconCircle } from '../assets/threadsCircle.svg';
import { ReactComponent as LinkedinIconCircle } from '../assets/linkedinCircle.svg';
import { ReactComponent as ZhihuIconCircle } from '../assets/zhihuCircle.svg';
import { ReactComponent as PincongIconCircle } from '../assets/pincongCircle.svg';
import { ReactComponent as MaxIconCircle } from '../assets/maxCircle.svg';
import { ReactComponent as HupuIconCircle } from '../assets/hupuCircle.svg';
import { ReactComponent as WeiboIconCircle } from '../assets/weiboCircle.svg';
import { ReactComponent as DouyinIconCircle } from '../assets/douyinCircle.svg';
import { ReactComponent as DarkWebIconCircle } from '../assets/darkWeb-circle.svg';
import { ReactComponent as RedditIconCircle } from '../assets/reddit-circle.svg';
import { ReactComponent as BlueSkyIconCircle } from '../assets/blueSky-circle.svg';

export const platformIconsMapping: Record<string, React.ReactNode> = {
  TELEGRAM: <TelegramIcon />,
  VK: <VkontakteIcon />,
  TWITTER: <TwitterIcon />,
  WEB: <WebIcon />,
  FACEBOOK: <FacebookIcon />,
  ADMIXER: <WebIcon />,
  OK: <OkIcon />,
  YOUTUBE: <YoutubeIcon />,
  TIKTOK: <TikTokIcon />,
  INSTAGRAM: <InstagramIcon />,
  THREADS: <ThreadsIcon />,
  LINKEDIN: <LinkedinIcon />,
  MAX: <MaxIcon />,
  HUPU: <HupuIcon />,
  ZHIHU: <ZhihuIcon />,
  PINCONG: <PincongIcon />,
  WEIBO: <WeiboIcon />,
  DOUYIN: <DouyinIcon />,
  DARKWEB: <DarkWebIcon />,
  BLUESKY: <BlueSkyIcon />,
  REDDIT: <RedditIcon />,
};

export const platformIconsCircleMapping: Record<string, React.ReactNode> = {
  TELEGRAM: <TelegramIconCircle />,
  VK: <VkontakteIconCircle />,
  TWITTER: <TwitterIconCircle />,
  WEB: <WebIconCircle />,
  FACEBOOK: <FacebookIconCircle />,
  ADMIXER: <WebIconCircle />,
  OK: <OkIconCircle />,
  YOUTUBE: <YoutubeIconCircle />,
  TIKTOK: <TikTokIconCircle />,
  INSTAGRAM: <InstagramIconCircle />,
  THREADS: <ThreadsIconCircle />,
  LINKEDIN: <LinkedinIconCircle />,
  MAX: <MaxIconCircle />,
  HUPU: <HupuIconCircle />,
  ZHIHU: <ZhihuIconCircle />,
  PINCONG: <PincongIconCircle />,
  WEIBO: <WeiboIconCircle />,
  DOUYIN: <DouyinIconCircle />,
  DARKWEB: <DarkWebIconCircle />,
  BLUESKY: <BlueSkyIconCircle />,
  REDDIT: <RedditIconCircle />,
};

export const platformNamesMapping: Record<string, string> = {
  TELEGRAM: 'Telegram',
  VK: 'VK',
  TWITTER: 'Twitter',
  WEB: 'Web',
  FACEBOOK: 'Facebook',
  YOUTUBE: 'Youtube',
  OK: 'OK',
  TIKTOK: 'TikTok',
  INSTAGRAM: 'Instagram',
  THREADS: 'Threads',
  LINKEDIN: 'LinkedIn',
  MAX: 'Max',
  HUPU: 'Hupu',
  ZHIHU: 'Zhihu',
  PINCONG: 'Pincong',
  WEIBO: 'Weibo',
  DOUYIN: 'Douyin',
  DARKWEB: 'Darkweb',
  BLUESKY: 'Bluesky',
  REDDIT: 'Reddit',
};

export const platformOptions: { value: string; label: string }[] = [
  { value: 'TELEGRAM', label: platformNamesMapping['TELEGRAM'] },
  { value: 'TIKTOK', label: platformNamesMapping['TIKTOK'] },
  { value: 'VK', label: platformNamesMapping['VK'] },
  { value: 'TWITTER', label: platformNamesMapping['TWITTER'] },
  { value: 'WEB', label: platformNamesMapping['WEB'] },
  { value: 'FACEBOOK', label: platformNamesMapping['FACEBOOK'] },
  { value: 'YOUTUBE', label: platformNamesMapping['YOUTUBE'] },
  { value: 'INSTAGRAM', label: platformNamesMapping['INSTAGRAM'] },
  { value: 'OK', label: platformNamesMapping['OK'] },
  { value: 'THREADS', label: platformNamesMapping['THREADS'] },
  { value: 'LINKEDIN', label: platformNamesMapping['LINKEDIN'] },
  { value: 'MAX', label: platformNamesMapping['MAX'] },
  { value: 'HUPU', label: platformNamesMapping['HUPU'] },
  { value: 'ZHIHU', label: platformNamesMapping['ZHIHU'] },
  { value: 'PINCONG', label: platformNamesMapping['PINCONG'] },
  { value: 'WEIBO', label: platformNamesMapping['WEIBO'] },
  { value: 'DOUYIN', label: platformNamesMapping['DOUYIN'] },
  { value: 'DARKWEB', label: platformNamesMapping['DARKWEB'] },
  { value: 'BLUESKY', label: platformNamesMapping['BLUESKY'] },
  { value: 'REDDIT', label: platformNamesMapping['REDDIT'] },
];

export const platformMapping: Record<string, number> = {
  TELEGRAM: 1,
  FACEBOOK: 2,
  VK: 4,
  TWITTER: 3,
  WEB: 5,
  YOUTUBE: 7,
  TIKTOK: 8,
  INSTAGRAM: 9,
  OK: 6,
  THREADS: 10,
  LINKEDIN: 11,
  MAX: 12,
  ZHIHU: 13,
  PINCONG: 14,
  HUPU: 15,
  WEIBO: 16,
  DOUYIN: 17,
  DARKWEB: 18,
  BLUESKY: 19,
  REDDIT: 20,
};

export const availablePlatforms: string[] = [
  'TELEGRAM',
  'TIKTOK',
  'VK',
  'TWITTER',
  'WEB',
  'FACEBOOK',
  'YOUTUBE',
  'INSTAGRAM',
  'OK',
  'THREADS',
  'LINKEDIN',
  'MAX',
  'HUPU',
  'ZHIHU',
  'PINCONG',
  'WEIBO',
  'DOUYIN',
  'DARKWEB',
  'BLUESKY',
  'REDDIT',
];